import React, { Dispatch, SetStateAction } from 'react';
import { useNavigate } from 'react-router-dom';

import { MemberInput } from '../../types/MemberInput';
import MemberBlock from './MemberBlock';
import { PersonalInformation } from '../../types/PersonalInformation';

import globalStyles from '../../App.module.scss';
import familyStyles from './familyInformationPage.module.scss';
import { isValid, isValidOrEmptyPartner, isValidOrEmptyBarneList } from '../validation';
import { ValidationErrors } from './ValidationErrors';

interface FamilyMembersProps {
    familyMembers: MemberInput;
    formErrorsHovedmedlem: PersonalInformation;
    formErrorsPartner: PersonalInformation;
    formErrorsBarn: PersonalInformation[];
    setHovedmedlemInput: Dispatch<SetStateAction<PersonalInformation>>;
    setPartnerInput: Dispatch<SetStateAction<PersonalInformation | undefined>>;
    setBarnInput: Dispatch<SetStateAction<PersonalInformation[] | undefined>>;
}

export default function FamiliyMembers({
    familyMembers,
    formErrorsHovedmedlem,
    formErrorsPartner,
    formErrorsBarn,
    setHovedmedlemInput,
    setPartnerInput,
    setBarnInput,
}: FamilyMembersProps) {
    const navigate = useNavigate();

    const addPartnerBtnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        navigate('/personalia/familie/partner');
    };

    const addBarnBtnClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        const childId = (familyMembers.barn?.length ?? 0) + 1;
        navigate(`/personalia/familie/barn/${childId}`);
    };

    const familyIsValid =
        isValid(familyMembers.hovedmedlem) &&
        isValidOrEmptyPartner(familyMembers.partner) &&
        isValidOrEmptyBarneList(familyMembers.barn);

    return (
        <React.Fragment>
            <div className={familyStyles.familyMembers}>
                <h3>Medlemmer</h3>
                <p className={globalStyles.smallInfoText}>Du kan også legge til familiemedlemmer senere.</p>
                {!familyIsValid && (
                    <ValidationErrors
                        errorsHovedmedlem={formErrorsHovedmedlem}
                        errorsPartner={formErrorsPartner}
                        errorsBarn={formErrorsBarn}
                    />
                )}

                <MemberBlock
                    memberName={familyMembers.hovedmedlem.firstname + ' ' + familyMembers.hovedmedlem.lastname}
                    isHovedmedlem={true}
                    isBarn={false}
                />

                {familyMembers.partner && (
                    <MemberBlock
                        memberName={familyMembers.partner?.firstname + ' ' + familyMembers.partner?.lastname}
                        isHovedmedlem={false}
                        isBarn={false}
                    />
                )}
                {familyMembers.barn && (
                    <React.Fragment>
                        {familyMembers.barn?.map((barn, i) => (
                            <MemberBlock
                                key={i}
                                memberName={barn.firstname + ' ' + barn.lastname}
                                isHovedmedlem={false}
                                isBarn={true}
                                index={i}
                            />
                        ))}
                    </React.Fragment>
                )}
            </div>
            <div className={familyStyles.addButtonsSection}>
                {!familyMembers.partner && (
                    <button className={familyStyles.btnAddItem} onClick={addPartnerBtnClick}>
                        + Legg til ektefelle / samboer
                    </button>
                )}
                <button className={familyStyles.btnAddItem} onClick={addBarnBtnClick}>
                    + Legg til barn
                </button>
            </div>
        </React.Fragment>
    );
}
